// Gift Factory theme scripts
document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav / future interactivity hooks can go here.
});
